import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = {
  ref: "copyIcon",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  class: "bi bi-clipboard inline",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "data-toggle": "tooltip",
  "data-placement": "top",
  title: "Copy"
}
const _hoisted_3 = {
  ref: "copiedIcon",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  class: "bi bi-clipboard-check inline",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "data-placement": "top",
  title: "Copied!"
}

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CopyComponent',
  props: {
  content: {
    type: String,
    required: true,
  },
},
  setup(__props) {



const input = ref<HTMLInputElement | null>(null);
const recentlyClicked = ref(false);

function clicked() {
  if (input.value) {
    input.value.setAttribute('type', 'text');
    input.value.select();
    document.execCommand('copy');
    input.value.blur(); // Prevent keyboard from popping up on Android
    input.value.setAttribute('type', 'hidden');

    recentlyClicked.value = true;
    setTimeout(() => { recentlyClicked.value = false; }, 2000);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    onClick: clicked,
    class: "cursor-pointer ml-[0.8em]"
  }, [
    _createElementVNode("input", {
      type: "hidden",
      value: __props.content,
      ref_key: "input",
      ref: input
    }, null, 8, _hoisted_1),
    _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
      }, null, -1),
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
      }, null, -1)
    ]))], 512)), [
      [_vShow, !recentlyClicked.value]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
      }, null, -1),
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3zm4.354 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
      }, null, -1)
    ]))], 512)), [
      [_vShow, recentlyClicked.value]
    ])
  ]))
}
}

})